"use strict";
exports.__esModule = true;
exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Submitted"] = "SUBMITTED";
    OrderStatus["Accepted"] = "ACCEPTED";
    OrderStatus["Executed"] = "EXECUTED";
    OrderStatus["ManuallyExecuted"] = "MANUALLY_EXECUTED";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Exited"] = "EXITED";
    OrderStatus["Deferred"] = "DEFERRED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
